<template>
    <div>
        <h2>Preview</h2>
        <table class="preview">
            <template v-for="row in previewSchema">
                <tr :key="row.id">
                    <td :style="`padding-left:${ (row.level * 1) + .5 }em`">{{ label(row) }}</td>
                    <td v-for="(fs,index) in activeBSheet" :key="index">
                        {{ fs.lineItems[row.id]|formatNumber }}
                    </td>
                </tr>
            </template>
        </table>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: "preview",
    computed: {
        ...mapGetters(['previewSchema','activeBSheet']),
    },
    methods: {
        label(node) {
            let lang = this.$store.state.lang
            let prefLabel = node.preferredLabel
            return node.labels.filter(l => l.role==prefLabel && l.lang==lang).reduce(x => x).label
        },
    },
    created() {
        this.$store.dispatch('fetchSchema')
    }
}
</script>

<style>
.preview {
    border-collapse: collapse;
    border: solid 1px #ccc;
}
.preview td {
    border: solid 1px #ccc;
    text-align: right;
    min-width: 10em;
    padding: 0 .5em;
}
.preview td:first-child {
    text-align: left;
}
</style>